import { Book } from "../../types/book";

export function alternateSubscriptionPermissions(book: Book) {
    return {
        "permitApps": book.accountSource === 2 || book.accountSource === 3,
        "permitManual": book.subscriptionStrategy === 1,
        "permitPhysicians": book.accountSource === 1 || book.accountSource === 3,
    };
}
